(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("ParLaborController", ParLaborController);

    ParLaborController.$inject = [];

    function ParLaborController () {
        var self = this;
    }
})();